import { getGridSummaryCount, renderGridSummarySum, renderGridSummarySumTonnes, renderGridSummarySumHL } from 'components/global/utils';
import { TradesDistrictReportGridData } from '@pages/reporting-pages/deliveries-trades-district/types/TradesDistrictReportGridData';



interface GridSummaryProps<T> {
	data?: T[] | null,
}


const GridSummary = (props: GridSummaryProps<TradesDistrictReportGridData>) => {
	const { data } = props;

	return (
		<>
			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
				<p>{getGridSummaryCount(data)}</p>
			</div>


			<div className='app-grid-summary'>
				<p>{renderGridSummarySumHL(data, 'total_volume')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySumTonnes(data, 'total_weight')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySumTonnes(data, 'total_returnsWeight')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySum(data, 'total_ordersCount')}</p>
			</div>


			<div className='app-grid-summary'>
				<p>{renderGridSummarySumHL(data, 'sd_volume')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySumTonnes(data, 'sd_weight')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySumTonnes(data, 'sd_returnsWeight')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySum(data, 'sd_ordersCount')}</p>
			</div>


			<div className='app-grid-summary'>
				<p>{renderGridSummarySumHL(data, 'int_volume')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySumTonnes(data, 'int_weight')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySumTonnes(data, 'int_returnsWeight')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySum(data, 'int_ordersCount')}</p>
			</div>


			<div className='app-grid-summary'>
				<p>{renderGridSummarySumHL(data, 'dd_volume')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySumTonnes(data, 'dd_weight')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySumTonnes(data, 'dd_returnsWeight')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySum(data, 'dd_ordersCount')}</p>
			</div>


			<div className='app-grid-summary'>
				<p>{renderGridSummarySumHL(data, 'td_volume')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySumTonnes(data, 'td_weight')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySumTonnes(data, 'td_returnsWeight')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySum(data, 'td_ordersCount')}</p>
			</div>
		</>
	)
}

export default GridSummary;